import { RespCode } from '@constants';
import { logError } from '@log';
import { request } from './request';
// import { mockGetReviewData } from './mock';

/**
 * 选择商品之后获取 review 数据
 * @param {String} claimType 理赔类型
 * @param {String} policyId 保单 id
 */
export const reviewClaim = async (body) => {
  try {
    const resp = await request('review-claim', {
      body,
    });
    // console.log('review-claim 入参', body);
    // const resp = mockGetReviewData(body.issueType);
    const { code, data, message } = resp || {};
    if (code !== RespCode.Success) {
      logError(message);
      return null;
    }
    return data;
  } catch (error) {
    logError(error);
    return null;
  }
};
